import { render, staticRenderFns } from "./modifier_groups.vue?vue&type=template&id=4dfe9973"
import script from "./modifier_groups.vue?vue&type=script&lang=js"
export * from "./modifier_groups.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports